<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<supplier-csr :score1="score1" :score2="score2" :score3="score3" :score4="score4"
					:title="`Your Sustainability Score`" class="mb-5" />
			</v-col>
	
			<v-col cols="12">
				<v-card style="overflow: hidden; position: relative;" class="elevation-0">
					<canvas width="600" height="600" style="opacity: 0%; position: absolute;"
						class="ma-0 justify-center" ref="canvas"/>
				</v-card>
			</v-col>
		</v-row>
		<v-row  style="position: absolute; top: 60%; left: 100px;">
			<v-col v-if="this.scoreData.length>1" align = center>
				<p style="font-size: 20px;">Your Average Sustainability Score for <strong>{{this.year1}} : {{this.avgScore1}}% </strong>and for <strong>{{ this.year2}} : {{ this.avgScore2}}% </strong>.</p>
			</v-col>
			<v-col v-else align = center>
				<p>Your Average Sustainability Score for <strong>{{this.year1}} : {{this.avgScore1}}% </strong></p>
			</v-col>
		</v-row>
		<v-col align="right" style="position: absolute; top: 58%; left: -20px;">
				<p style="font-size: 20px; font-weight: bold;">Filled out : {{ this.filledoutdate }}</p>
		</v-col>
	</v-container>
</template>

<script>
import LoadingState from "../consts/LoadingState"
import CsrAPI from "../api/csr/csr"
export default {
	name: "CSR-Submission-View",
	props: {
		selectedYear: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			scoreData: [],
			csr: null,
			csrData: null,
			csrScore: [null, null, null, null],
			score1: null,
			score2: null,
			score3: null,
			score4: null,
			avgScore1: 0 ,
			avgScore2: 0 ,
			year1:0,
			year2:0,
			filledoutdate: "",
		}
	},
	mounted() {
		this.getCsrScore()
		this.loadData()
	},
	methods: {
		getCsrScore() {
			this.csrScore = [null, null, null, null]

			CsrAPI.getCSRForm()
				.then(data => {	
								
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{
							root: true
						}
					)
					if (data.csrID) {
						CsrAPI.getCSRAssessment(data.csrID)
							.then(result => {
								
								let csr = result[0]
								console.log(csr.timestamp)
								if (csr.timestamp) {
									const date = new Date(csr.timestamp)
									const month = date.toLocaleString("default", { month: "short" })
									const year = date.getFullYear()
									this.filledoutdate = `${month} ${year}`
								}
								if (csr) {
									this.csrScore = [
										csr.score1,
										csr.score2,
										csr.score3,
										csr.score4
									]
								}
								this.score1 = Math.round(this.csrScore[0]),
								this.score2 = Math.round(this.csrScore[1]),
								this.score3 = Math.round(this.csrScore[2]),
								this.score4 = Math.round(this.csrScore[3])
							})
							.catch(error => {
								console.log(error)
							})
					}
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
					this.csrScore = [null, null, null, null]
				})
		},
		// shouldDisplay(question) {
		// 	if (question.type == "spacer") {
		// 		return true
		// 	}
		// 	if (question.visible == true) {
		// 		return true
		// 	}
		// 	return false
		// },
		loadData() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			CsrAPI.getCSRAssessmentsall()
				.then((result) => {
					
					result[0].forEach((item) => {
						const date = new Date(item.timestamp)
						const year = date.getFullYear()
						this.scoreData.push({
							year: year,
							score1: item.score1,
							score2: item.score2,
							score3: item.score3,
							score4: item.score4,
						})
					})
					console.log(this.scoreData)
					if(this.scoreData){
						this.avgScore1=Math.round((this.scoreData[0].score1 +this.scoreData[0].score2 +this.scoreData[0].score3 +this.scoreData[0].score4) /4)
						this.year1=this.scoreData[0].year
						console.log(this.avgScore1)
					}
					if(this.scoreData.length>1){
						this.avgScore2=Math.round((this.scoreData[1].score1 +this.scoreData[1].score2 +this.scoreData[1].score3 +this.scoreData[1].score4) /4)
						this.year2=this.scoreData[1].year
						console.log(this.avgScore2)
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		downloadCanvas() {
			var canvas = this.$refs.canvas
			var context = canvas.getContext("2d")
			var imageObj = new Image()
			let clientName = this.$store.getters["user/getUser"].clientName
			imageObj.onload = () => {
				context.drawImage(imageObj, 0, 0, 600, 600)
				context.font = "35pt Sarabun"
				context.fillStyle = "white"
				context.fillText(clientName, 32, 120, 375)
				this.downloadPng()
			}
			imageObj.src = require("../assets/survey-badge-new.jpg")
		},
	},
}
</script>
